import React from 'react';

import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpcomingWebinarsPanel = ({ webinars = [] }) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const isUpcoming = (date) => {
    return new Date(date) > new Date();
  };

  const upcomingWebinars = webinars?.filter(webinar => isUpcoming(webinar?.date));

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Upcoming Webinars</h3>
        <Button variant="ghost" size="sm" iconName="Calendar">
          View Calendar
        </Button>
      </div>
      {upcomingWebinars?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Calendar" size={32} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground mb-2">No upcoming webinars</p>
          <p className="text-xs text-muted-foreground">Check back soon for new sessions</p>
        </div>
      ) : (
        <div className="space-y-4">
          {upcomingWebinars?.slice(0, 3)?.map((webinar) => (
            <div key={webinar?.id} className="p-4 border border-border rounded-lg hover:shadow-subtle transition-smooth">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-foreground mb-1 line-clamp-2">
                    {webinar?.title}
                  </h4>
                  <p className="text-xs text-muted-foreground mb-2 line-clamp-2">
                    {webinar?.description}
                  </p>
                </div>
                
                {webinar?.isFree && (
                  <span className="text-xs text-success bg-success/10 px-2 py-1 rounded-full ml-2">
                    Free
                  </span>
                )}
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                  <Icon name="Calendar" size={12} />
                  <span>{formatDate(webinar?.date)}</span>
                  <Icon name="Users" size={12} />
                  <span>{webinar?.attendees} registered</span>
                </div>
                
                <Button variant="outline" size="sm" iconName="ExternalLink">
                  Register
                </Button>
              </div>
              
              {webinar?.speaker && (
                <div className="mt-3 pt-3 border-t border-border">
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                      <span className="text-xs text-primary-foreground font-medium">
                        {webinar?.speaker?.charAt(0)}
                      </span>
                    </div>
                    <span className="text-xs text-muted-foreground">
                      Speaker: {webinar?.speaker}
                    </span>
                  </div>
                </div>
              )}
            </div>
          ))}
          
          {upcomingWebinars?.length > 3 && (
            <div className="pt-3 border-t border-border text-center">
              <Button variant="ghost" size="sm" iconName="Plus">
                View {upcomingWebinars?.length - 3} More Webinars
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UpcomingWebinarsPanel;